import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-8 col-lg-6 col-xxl-5" }
const _hoisted_4 = { class: "col-md-4 col-lg-6 col-xxl-7" }
const _hoisted_5 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumbItem = _resolveComponent("FKBreadCrumbItem")!
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_CenterInfo = _resolveComponent("CenterInfo")!
  const _component_CenterStats = _resolveComponent("CenterStats")!
  const _component_CenterCreateRoles = _resolveComponent("CenterCreateRoles")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, {
      page: `${_ctx.center.name}`
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.$t('page.centers'),
          to: "/system-centers"
        }, null, 8 /* PROPS */, ["page"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_CenterInfo)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_CenterStats, {
            id: _ctx.id,
            ref: "stats"
          }, null, 8 /* PROPS */, ["id"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_CenterCreateRoles, {
          id: _ctx.id,
          onUpdate: _ctx.refreshStats
        }, null, 8 /* PROPS */, ["id", "onUpdate"])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}